export const LINE_HEIGHT_DEFAULT = 1.5;
export const LINE_HEIGHT_OPTIONS = [1.0, 1.15, 1.5, 2.0, 2.5, 3.0];
// bulletList/orderedList included — line-height applied to container, affects all items inside
export const LINE_HEIGHT_TYPES = ['paragraph', 'heading', 'bulletList', 'orderedList'];
